import { z } from 'zod';

// Minimum we enforce anywhere a password is set (login is not subject to it — an
// existing weaker password must still be accepted until reset).
export const MIN_PASSWORD_LENGTH = 8;

export const LoginRequestSchema = z.object({
  email: z.email(),
  password: z.string().min(1),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

// The refresh token rides in an httpOnly cookie the FE never reads; only the
// access token is returned in the body and held in memory.
export const AccessTokenResponseSchema = z.object({
  accessToken: z.string().min(1),
  expiresInSeconds: z.number().int().positive(),
});
export type AccessTokenResponse = z.infer<typeof AccessTokenResponseSchema>;

export const ResetRequestSchema = z.object({
  email: z.email(),
});
export type ResetRequest = z.infer<typeof ResetRequestSchema>;

// Serves both the welcome (set-initial-password) and forgot-password flows.
export const ResetPasswordSchema = z.object({
  token: z.string().min(1),
  newPassword: z.string().min(MIN_PASSWORD_LENGTH),
});
export type ResetPassword = z.infer<typeof ResetPasswordSchema>;

export const MessageResponseSchema = z.object({
  message: z.string(),
});
export type MessageResponse = z.infer<typeof MessageResponseSchema>;

export const GoogleSignInStatusSchema = z.object({
  enabled: z.boolean(),
});
export type GoogleSignInStatus = z.infer<typeof GoogleSignInStatusSchema>;

export const GOOGLE_SIGN_IN_ERRORS = ['unavailable', 'domain', 'no_access', 'failed'] as const;
export const GoogleSignInErrorSchema = z.enum(GOOGLE_SIGN_IN_ERRORS);
export type GoogleSignInError = z.infer<typeof GoogleSignInErrorSchema>;
